import { useEffect, useRef, useState } from 'react';

const useCopyToClipboard = (generateLink, { autoResetMs } = {}) => {
  const [copied, setCopied] = useState(false);
  const resetTimerRef = useRef(null);

  const linkText = generateLink();

  // Clean up any pending timer on unmount so we don't setState on a
  // gone component.
  useEffect(() => () => {
    if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
  }, []);

  const handleCopy = () => {
    setCopied(true);

    if (autoResetMs) {
      if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
      resetTimerRef.current = setTimeout(() => {
        setCopied(false);
        resetTimerRef.current = null;
      }, autoResetMs);
    }
  };

  const handleMouseLeave = () => {
    if (copied) {
      setCopied(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.currentTarget.click();
    }
  };

  return {
    copied,
    linkText,
    handleCopy,
    handleMouseLeave,
    handleKeyDown,
  };
};

export default useCopyToClipboard;
